import { render, staticRenderFns } from "./AdminMegaMenu.vue?vue&type=template&id=dc2b58c4"
import script from "./AdminMegaMenu.vue?vue&type=script&lang=js"
export * from "./AdminMegaMenu.vue?vue&type=script&lang=js"
import style0 from "./AdminMegaMenu.vue?vue&type=style&index=0&id=dc2b58c4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports